const LEGAL_BASE = 'https://aslgo.com/legal';

/** "Read the Privacy Policy & Terms of Use", pointing at the published pages.
 *  Both registration forms used to open an in-app modal holding their own copy
 *  of the legal text, which could only ever drift from the real thing;
 *  aslgo.com/legal is authoritative. Opens in a new tab so a half-filled
 *  registration form is never lost. */
export function LegalLinks() {
  return (
    <span className="text-[0.8rem] text-ink-600 dark:text-ink-400 self-start">
      Read the <LegalLink section="Privacy">Privacy Policy</LegalLink>
      {' & '}
      <LegalLink section="Terms">Terms of Use</LegalLink>
    </span>
  );
}

function LegalLink({ section, children }: { section: string; children: string }) {
  return (
    <a
      href={`${LEGAL_BASE}#${section}`}
      target="_blank"
      rel="noopener noreferrer"
      className="underline hover:text-ink-800 dark:hover:text-ink-100"
    >
      {children}
    </a>
  );
}
